import React from "react";
import classnames from "classnames";
import ArrowIcon from "@material-ui/icons/KeyboardArrowDown";

import "../styles/scrollArrow.scss";

export default props => {
  return (
    <ArrowIcon
      className={classnames("scrollArrow", {
        "scrollArrow--visible": props.visible
      })}
    />
  );
};
